import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import styled from "styled-components";
import { useScreenWidth } from "../../helper/screentWidth";

function CustomDropdown({
  Title,
  Active = true,
  value,
  options = [],
  onChange,
  firstmeeting = false,
}) {
  const [selectedName, setSelectedName] = useState("");
  const screenWidth = useScreenWidth();

  useEffect(() => {
    if (options.length > 0) {
      const selectedOption = options.find((option) => option.value === value);
      if (selectedOption) {
        setSelectedName(selectedOption.text);
      } else {
        setSelectedName("");
      }
    } else {
      setSelectedName("");
    }
  }, [value, options]);

  const handleChange = (event, data) => {
    onChange(data.value);

    const selectedOption = options.find(
      (option) => option.value === data.value
    );
    if (selectedOption) {
      setSelectedName(selectedOption.text);
    }
  };

  return (
    <Container firstmeeting={firstmeeting}>
      <FieldName firstmeeting={firstmeeting}>{Title}</FieldName>
        <StyledDropdown
          placeholder="Select an option"
          fluid
          search
          selection
          disabled={!Active}
          onChange={handleChange}
          value={value}
          options={options} // Pass options to the Dropdown
        />
      
    </Container>
  );
}

// Styled components
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr ;
  align-items: center;
  width: 100%;

  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    grid-template-columns: 1fr;
    gap: 10px;
    max-height: 100px;
  }
`;

const FieldName = styled.div`
  white-space: nowrap;
    justify-self: start;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  font-style: italic;
  font-weight: 300;

  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    justify-self: start;
    padding: 20px 0px 0px 0px;
  }
`;

const Text = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  min-width: 120px;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;
  
`;

const StyledDropdown = styled(Dropdown)`
  background: var(--editable) !important;
  border: none !important;
  width: 100%;

  &.ui.selection.dropdown {
    min-height: 30px !important;
    border-radius: 20px !important;
    padding: 0 35px 0 10px !important; /* Match padding-left: 10px */
    line-height: 30px !important;
    
    color: #304961 !important;
    font-family: "Museo Sans Cyrl" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border: none !important;
    outline: none !important;
  }

  &.ui.disabled.dropdown {
    opacity: 0.5 !important;
  }

  & > .text,
  & > .default.text {
    line-height: 30px !important;
    padding: 0 !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #304961 !important;
  }

  & > .default.text {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #8a9ba8 !important;
  }

  & input.search {
    padding: 0 !important;
    line-height: 30px !important;
    height: 30px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
  }

  & > .dropdown.icon {
    top: 50% !important;
    transform: translateY(-50%) !important;
    right: 10px !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  & > .menu {
    border-radius: 20px !important;
    margin-top: 4px !important;
  }
`;

  


export default CustomDropdown;
